module.exports = __webpack_public_path__ + "static/minecraft-logo-line-82461388e4bd043f7cf5287cff56af45.png";